/* eslint-disable import/prefer-default-export */
import { createAction } from "redux-actions";

export const setSidebarCommentsData = createAction("SET_SIDEBAR_COMMENTS_DATA");
export const sidebarAddComment = createAction("SIDEBAR_ADD_COMMENT");
export const sidebarRemoveComment = createAction("SIDEBAR_REMOVE_COMMENT");
